import React, { FC, ReactNode, useEffect } from 'react';
import Header from './Header';
import Footer from './Footer';
import { useProjectConfigContext } from '../../../contexts/ProjectConfigContext';
import { useParams } from 'react-router-dom';
import LoadingModal from '../../LoadingModal';
import Style from '../../../styles/components/layout.module.css';
import { useGetLangDirectionApp } from '../../../stores/app.store';


type TypePage = {
    children: ReactNode;
    userAlert?: ReactNode;
    modals?: ReactNode;
    isLoading?: boolean;
}

const Page: FC<TypePage> = ({ children, userAlert, modals, isLoading }) => {

    const params = useParams();
    const { setProjectId, authState, isProjectConfigLoading } = useProjectConfigContext();
    const langDirection = useGetLangDirectionApp();

    const projectId = params.projectId;

    useEffect(() => {

        const projectIdInt = Number(projectId);

        if (!isNaN(projectIdInt)) {
            setProjectId(projectIdInt);
        } else {
            console.error("Invalid projectId in URL:", params.projectId);
        }
    }, [projectId]);

    useEffect(() => {

        document.body.dir = langDirection;

        return () => {
            document.body.dir = 'rtl';
        };
    }, [langDirection]);

    return (
        <>
            <LoadingModal show={isProjectConfigLoading || isLoading} />

            {modals}

            <div className={Style.page} >
                {authState.loggin ? <Header /> : ''}
                <div className={Style.userAlertDiv}>
                    {userAlert}
                </div>

                <div className={Style.mainContent}>
                    {children}
                </div>

                <Footer />
            </div>
        </>
    );
}

export default Page;